import "./style.css";

// 
const Footer = () => {
  return (
    <>
      <div className="footer">
        <span>
          Copyright &copy; 2022, Lucky Resources & Logistics Co. Ltd.
        </span>
      </div>
    </>
  );
};

export default Footer;
